;
(function ($, _) {

    // Only do this stuff if we have vue and are on the search page:
    if ('undefined' === typeof(Vue)) return false;
    if (!$('body.page-template-template-member-search-php').length) return false;

    const APP_CONTAINER_ID = 'member_search';

    const search_data = ('undefined' == typeof(window.firm_data ) ) ?
        [] : window.firm_data.sort((a, b) => {
                if(a.name < b.name ) return -1;
                if (a.name > b.name) return 1;
                return 0;
        });

    const firm_types = search_data.map( (el => {
            return el.meta.firm_type;
        })).filter(function (value, index, self) { // only uniq values
            return self.indexOf(value) === index;
        });

    const states = search_data.reduce( (acc, el) => {
            const new_acc = acc.concat(el.meta.firm_search_state);
            return new_acc;
        }, []).filter(function (value, index, self) { // only uniq values
            return self.indexOf(value) === index;
        }).sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });

    const countries = search_data.map( (el => {
            return el.meta.firm_country;
        })).filter(function (value, index, self) { // only uniq values
            return self.indexOf(value) === index;
        });

    const sort_orders = [
        'Alphabetical',
        'Location Name'
    ];

    const urlParams = new URLSearchParams(window.location.search);
    const query_search_state = urlParams.has('state') ?
        urlParams.get('state') : false;
    const query_search_string = urlParams.has('search_string') ?
        urlParams.get('search_string') : false;


    var app = new Vue({
        el: '#' + APP_CONTAINER_ID,
        data: {
            members: search_data,
            states: states,
            countries: countries,
            firm_types: firm_types,
            current_page: 0,
            results_per_page: 20,
            sort_order: sort_orders[0],
            sort_orders: sort_orders,
            filter_val_name: query_search_string ? query_search_string :'',
            filter_val_location: query_search_state ? query_search_state : '',
            filter_val_type: ''
        },
        computed: {
            filtered_responses: function () {
                this.current_page = 0;
                const return_set = this.members.filter( (el) => {
                        // Type
                    return ("" === this.filter_val_location || _.contains(el.meta.firm_search_state, this.filter_val_location));
                    }).filter( (el) => {
                        // Type
                        return ("" === this.filter_val_type || el.meta.firm_type == this.filter_val_type);
                    }).filter( (el) => {
                        if ("" === this.filter_val_name) return true;

                        const string_set = this.filter_val_name.split(' ').filter(el => el != '');
                        const search_regex = new RegExp(string_set.join('|'), 'i');
                        return search_regex.exec(el.name);
                    }).sort(this.sort_ordering);
                return return_set;
            },
            paginated_text: function () {
                const start = (this.current_page * this.results_per_page) + 1;
                const total = this.filtered_responses.length;
                const end = (start + this.results_per_page > total) ? total : start + this.results_per_page;

                if (!total) return '';
                return `Showing ${start}-${end} of ${total} Results`;
            },
            paginated_responses: function () {
                const start_index = this.current_page * this.results_per_page;
                const end_index = start_index + this.results_per_page;
                return this.filtered_responses.slice(start_index, end_index);
            },
            pagination_control_text: function () {
                const total = this.filtered_responses.length;
                if (!total) return '';

                const total_pages = this.pagnation_number_of_pages > 2 ? this.pagnation_number_of_pages : 2;

                return `${this.current_page + 1} OF ${total_pages - 1}`;
            },
            pagnation_number_of_pages: function () {
                return Math.ceil((this.filtered_responses.length + this.results_per_page - 1) / this.results_per_page);
            },
            pagnation_has_next: function () {
                return (this.current_page + 2) < this.pagnation_number_of_pages;
            },
            pagnation_has_prev: function () {
                return this.current_page > 0;
            }
        },
        methods: {
            sort_ordering: function (a, b) {

                switch (this.sort_order) {
                    case 'Location Name':

                        if(a.meta.city_state < b.meta.city_state ) return -1;
                        if (a.meta.city_state > b.meta.city_state) return 1;
                        return 0;

                        break;

                    case 'Alphabetical':
                    default:

                        if(a.name < b.name ) return -1;
                        if (a.name > b.name) return 1;
                        return 0;

                        break;
                }
            },
            page_next: function () {
                if (this.pagnation_has_next) this.current_page++;
            },
            page_prev: function () {
                if (this.pagnation_has_prev) this.current_page--;
            }

        }
    });

})
(jQuery, _);
